import clsx from 'clsx';
import React, { ReactElement } from 'react';
import { TFunction } from 'i18next';
import { HotlineConfig } from './HotlineConfig';

export const getHotlineOpeningHoursPlainText = (config: HotlineConfig, translationT: TFunction): string => {
  const businessDaysSuffix = translationT('hotline-opening-hours.business-days');
  const saturdaysSuffix = translationT('hotline-opening-hours.saturdays');
  const sundaysAndHolidaysSuffix = translationT('hotline-opening-hours.sunday-and-holidays');
  const costText = translationT('hotline-opening-hours.cost-info');
  const separator = `, `;
  const businessDaysPart = config.businessDays.openingHour ? `${config.businessDays.openingHour}-${config.businessDays.closingHour} ${businessDaysSuffix}${separator}` : '';
  const saturdayPart = config.saturdays.openingHour ? `${config.saturdays.openingHour}-${config.saturdays.closingHour} ${saturdaysSuffix}${separator}` : '';
  const sundayPart = config.sundaysAndHolidays.openingHour ? `${config.sundaysAndHolidays.openingHour}-${config.sundaysAndHolidays.closingHour} ${sundaysAndHolidaysSuffix}${separator}` : '';
  const costPart = costText ?? '';

  return businessDaysPart + saturdayPart + sundayPart + costPart;
};

export const getHotlineOpeningHoursHeaderVersion = (config: HotlineConfig, translationT: TFunction, costPartStyle?: string): ReactElement => {
  const businessDaysPrefix = translationT('hotline-opening-hours.business-days-alternative');
  const saturdaysPrefix = translationT('hotline-opening-hours.saturdays-alternative');
  const sundaysAndHolidaysPrefix = translationT('hotline-opening-hours.sunday-and-holidays-alternative');
  const costText = translationT('hotline-opening-hours.cost-info-alternative');
  const separator = <br/>;
  const businessDaysPart = config.businessDays.openingHour ? `${businessDaysPrefix} ${config.businessDays.openingHour}-${config.businessDays.closingHour}` : undefined;
  const saturdayPart = config.saturdays.openingHour ? `${saturdaysPrefix} ${config.saturdays.openingHour}-${config.saturdays.closingHour}` : undefined;
  const sundayPart = config.sundaysAndHolidays.openingHour ? `${sundaysAndHolidaysPrefix} ${config.sundaysAndHolidays.openingHour}-${config.sundaysAndHolidays.closingHour}` : undefined;
  const costPart = costText ?? '';

  return <>
    {businessDaysPart && <>{businessDaysPart}{separator}</>}
    {saturdayPart && <>{saturdayPart}{separator}</>}
    {sundayPart && <>{sundayPart}{separator}</>}
    <span className={clsx(costPartStyle)}>{costPart}</span>
  </>;
};